function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#626260;stroke-linecap:round;stroke-linejoin:round;stroke-width:11px;}"));

var _ref3 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 8.5,
  y1: 93.75,
  x2: 8.5,
  y2: 118.75
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 49,
  y1: 78.25,
  x2: 8.82,
  y2: 118.43
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 33.5,
  y1: 118.75,
  x2: 8.5,
  y2: 118.75
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 8.5,
  y1: 34.25,
  x2: 8.5,
  y2: 9.25
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 49,
  y1: 49.75,
  x2: 8.82,
  y2: 9.57
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 33.5,
  y1: 9.25,
  x2: 8.5,
  y2: 9.25
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 119,
  y1: 34.75,
  x2: 119,
  y2: 9.75
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 78.5,
  y1: 50.25,
  x2: 118.68,
  y2: 10.07
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 94,
  y1: 9.75,
  x2: 119,
  y2: 9.75
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 119.5,
  y1: 93.75,
  x2: 119.5,
  y2: 118.75
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 79,
  y1: 78.25,
  x2: 119.18,
  y2: 118.43
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 94.5,
  y1: 118.75,
  x2: 119.5,
  y2: 118.75
});

function SvgIconFullscreenExpandV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "expand",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreenExpandV2);
export default __webpack_public_path__ + "static/media/icon_fullscreen_expand_v2.9f4ead30.svg";
export { ForwardRef as ReactComponent };